export const periodData = [
  {
    value: 3,
    label: "3 dias",
  },
  {
    value: 7,
    label: "7 dias",
  },
  {
    value: 15,
    label: "15 dias",
  },
  {
    value: 30,
    label: "30 dias",
  },
];

export const farmsMock = {
  success: true,
  error: "",
  data: [
    {
      id: 1,
      name: "Fazenda Itumbiara",
      external_id: 1,
    },
    {
      id: 2,
      name: "Fazenda Chapadao do Sul ",
      external_id: 2,
    },
    {
      id: 3,
      name: "Fazenda Sol Nascente",
      external_id: 3,
    },
    {
      id: 4,
      name: "Fazenda 3 Coracoes",
      external_id: 4,
    },
    {
      id: 5,
      name: "Fazenda Bom Jesus",
      external_id: 5,
    },
    {
      id: 6,
      name: "Fazenda Soja Boa",
      external_id: 6,
    },
    {
      id: 7,
      name: "Goldie",
      external_id: 7,
    },
    {
      id: 8,
      name: "Charlie",
      external_id: 8,
    },
    {
      id: 9,
      name: "Gregory",
      external_id: 9,
    },
    {
      id: 10,
      name: "Ari",
      external_id: 10,
    },
    {
      id: 11,
      name: "Fabe",
      external_id: 11,
    },
    {
      id: 12,
      name: "Celine",
      external_id: 12,
    },
    {
      id: 13,
      name: "Sean",
      external_id: 13,
    },
    {
      id: 14,
      name: "Rozina",
      external_id: 14,
    },
    {
      id: 15,
      name: "Lewie",
      external_id: 15,
    },
    {
      id: 16,
      name: "Anallise",
      external_id: 16,
    },
    {
      id: 17,
      name: "Buddie",
      external_id: 17,
    },
    {
      id: 18,
      name: "Kacey",
      external_id: 18,
    },
    {
      id: 19,
      name: "Kendal",
      external_id: 19,
    },
    {
      id: 20,
      name: "Jodee",
      external_id: 20,
    },
  ],
};

export const ocsMock = {
  success: true,
  error: "",
  data: [
    {
      id: 1,
      name: "123134",
      external_id: 1,
    },
    {
      id: 2,
      name: "123134 ",
      external_id: 2,
    },
    {
      id: 3,
      name: "123134",
      external_id: 3,
    },
    {
      id: 4,
      name: "123134",
      external_id: 4,
    },
    {
      id: 5,
      name: "123134",
      external_id: 5,
    },
    {
      id: 6,
      name: "123134",
      external_id: 6,
    },
    {
      id: 7,
      name: "Goldie",
      external_id: 7,
    },
    {
      id: 8,
      name: "Charlie",
      external_id: 8,
    },
    {
      id: 9,
      name: "Gregory",
      external_id: 9,
    },
    {
      id: 10,
      name: "Ari",
      external_id: 10,
    },
    {
      id: 11,
      name: "Fabe",
      external_id: 11,
    },
    {
      id: 12,
      name: "Celine",
      external_id: 12,
    },
    {
      id: 13,
      name: "Sean",
      external_id: 13,
    },
    {
      id: 14,
      name: "Rozina",
      external_id: 14,
    },
    {
      id: 15,
      name: "Lewie",
      external_id: 15,
    },
    {
      id: 16,
      name: "Anallise",
      external_id: 16,
    },
    {
      id: 17,
      name: "Buddie",
      external_id: 17,
    },
    {
      id: 18,
      name: "Kacey",
      external_id: 18,
    },
    {
      id: 19,
      name: "Kendal",
      external_id: 19,
    },
    {
      id: 20,
      name: "Jodee",
      external_id: 20,
    },
  ],
};

export const transporterMock = {
  success: true,
  error: "",
  data: [
    {
      id: 1,
      name: "Transportadora Paraiso",
      external_id: 1,
    },
    {
      id: 2,
      name: "Levando tudo Transportadora ",
      external_id: 2,
    },
    {
      id: 3,
      name: "Transportando o mundo LTDA.",
      external_id: 3,
    },
    {
      id: 4,
      name: "123134",
      external_id: 4,
    },
    {
      id: 5,
      name: "123134",
      external_id: 5,
    },
    {
      id: 6,
      name: "123134",
      external_id: 6,
    },
    {
      id: 7,
      name: "Goldie",
      external_id: 7,
    },
    {
      id: 8,
      name: "Charlie",
      external_id: 8,
    },
    {
      id: 9,
      name: "Gregory",
      external_id: 9,
    },
    {
      id: 10,
      name: "Ari",
      external_id: 10,
    },
    {
      id: 11,
      name: "Fabe",
      external_id: 11,
    },
    {
      id: 12,
      name: "Celine",
      external_id: 12,
    },
    {
      id: 13,
      name: "Sean",
      external_id: 13,
    },
    {
      id: 14,
      name: "Rozina",
      external_id: 14,
    },
    {
      id: 15,
      name: "Lewie",
      external_id: 15,
    },
    {
      id: 16,
      name: "Anallise",
      external_id: 16,
    },
    {
      id: 17,
      name: "Buddie",
      external_id: 17,
    },
    {
      id: 18,
      name: "Kacey",
      external_id: 18,
    },
    {
      id: 19,
      name: "Kendal",
      external_id: 19,
    },
    {
      id: 20,
      name: "Jodee",
      external_id: 20,
    },
  ],
};
